import api from './api';

const financeService = {
  // Get all payments
  getAllPayments: async (params = {}) => {
    const response = await api.get('/finance', { params });
    return response.data;
  },

  // Get patient payments
  getPatientPayments: async (patientId) => {
    const response = await api.get(`/finance/patient/${patientId}`);
    return response.data;
  },

  // Add payment
  addPayment: async (paymentData) => {
    const response = await api.post('/finance', paymentData);
    return response.data;
  },

  // Update payment
  updatePayment: async (id, paymentData) => {
    const response = await api.put(`/finance/${id}`, paymentData);
    return response.data;
  },

  // Delete payment
  deletePayment: async (id) => {
    const response = await api.delete(`/finance/${id}`);
    return response.data;
  },

  // Get pending payments
  getPendingPayments: async () => {
    const response = await api.get('/finance/pending');
    return response.data;
  },

  // Get statistics
  getFinanceStats: async () => {
    const response = await api.get('/finance/stats');
    return response.data;
  },

  // Get patient-wise summary
  getPatientSummary: async () => {
    const response = await api.get('/finance/summary');
    return response.data;
  },

  // Get financial analytics
  getFinanceAnalytics: async (startDate, endDate) => {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const response = await api.get('/analytics/finance', { params });
    return response.data;
  },
};

export default financeService;